var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandpan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 59,
    viewBox: "0 0 92 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 29C0 12.9837 12.9837 0 29 0H63C79.0163 0 92 12.9837 92 29V29H0V29Z",
    fill: "#F57B17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 46.0163 12.9837 59 29 59H63C79.0163 59 92 46.0163 92 30V30H0V30Z",
    fill: "#F57B17"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 45,
    r: 5,
    fill: "#F57B17",
    stroke: "black",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17,
    r: 5,
    fill: "#F57B17",
    stroke: "black",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 45,
    r: 5,
    fill: "#F57B17",
    stroke: "black",
    strokeWidth: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 17,
    r: 5,
    fill: "#F57B17",
    stroke: "black",
    strokeWidth: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 45,
    r: 5,
    fill: "#F57B17",
    stroke: "black",
    strokeWidth: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 17,
    r: 5,
    fill: "#F57B17",
    stroke: "black",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandpan);
export default __webpack_public_path__ + "static/media/handpan.68fc050cf4fe6f7f6cb8198b182ad0be.svg";
export { ForwardRef as ReactComponent };